import { render, staticRenderFns } from "./SuiviProspect.vue?vue&type=template&id=42a08681"
import script from "./SuiviProspect.vue?vue&type=script&lang=js"
export * from "./SuiviProspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports